import React from "react";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import FormField from "../fields/FormField";
import drupalSettings from "../../../../Helpers/drupalSettings";

const ReCAPTCHAInput = props => {
  const { name, setFieldValue, wrapperClass } = props;
  const reCaptchaKey = drupalSettings.ed_dashboard.recaptcha_site_key;

  // Force Recaptcha to use Recaptcha.net API source.
  // This is to allow Recaptcha to be used in areas where Google is blocked.
  window.recaptchaOptions = {
    useRecaptchaNet: true
  };

  if (reCaptchaKey) {
    return (
      <FormField classes={wrapperClass} name={name}>
        <ReCAPTCHA
          sitekey={drupalSettings.ed_dashboard.recaptcha_site_key}
          onChange={response => {
            setFieldValue(name, response, true);
          }}
        />
      </FormField>
    );
  }

  return null;
};

ReCAPTCHAInput.propTypes = {
  name: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired
};

ReCAPTCHAInput.defaultProps = {
  wrapperClass: "form-item form-item__recaptcha"
};

export default ReCAPTCHAInput;
